export default __webpack_public_path__ + "static/media/pharma-inte.b37475f9.jpg";